var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"promotionArea"},[_c('PopularGameTitle'),_c('PopularGameList',{attrs:{"gameList":_vm.gamelist,"language":_vm.language}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }